// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-back-button {\n  margin-left: 12px;\n}", "",{"version":3,"sources":["webpack://src/pages/BotManagement/BotManagement.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ","sourcesContent":[".custom-back-button {\n    margin-left: 12px; // İstenilen miktarı ayarlayabilirsiniz\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
